(() => {
  const norm = value => value.trim().toLowerCase();
  const looksSku = value => /^[a-z]{2,}[- ]?\d[\w-]*$/i.test(value.trim());
  const base = (window.Shopify?.routes?.root || '/') + 'search';
  const request = async (term, signal) => {
    const params = new URLSearchParams({q:term,type:'product',view:'ek-live','options[prefix]':'last','options[unavailable_products]':'last'});
    const response = await fetch(base + '?' + params, {signal});
    if (!response.ok) throw new Error('Search unavailable');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    return [...doc.querySelectorAll('[data-ek-live-item]')];
  };
  const ranked = (items, term) => {
    const seen = new Set();
    return items.filter(item => {const url=item.dataset.url;if(seen.has(url))return false;seen.add(url);return true;}).sort((a,b) => {
      const score = item => item.dataset.exactSku === 'true' ? 0 : norm(item.dataset.title) === norm(term) ? 1 : 2;
      return score(a)-score(b);
    });
  };
  document.querySelectorAll('[data-ek-live-search]').forEach((form, formIndex)=>{
    const input=form.querySelector('input[name="q"]');
    const panel=document.createElement('div');panel.id='EkLiveSearchResults'+formIndex;input.setAttribute('aria-controls',panel.id);panel.className='ekl-search-panel';panel.hidden=true;panel.setAttribute('aria-label',input.getAttribute('placeholder')||'Search');
    const status=document.createElement('div');status.className='ekl-search-status';status.setAttribute('role','status');
    const list=document.createElement('div');panel.append(status,list);form.append(panel);
    let timer,controller;
    const hide=()=>{panel.hidden=true;input.setAttribute('aria-expanded','false');};
    input.addEventListener('input',()=>{
      clearTimeout(timer);controller?.abort();const term=input.value.trim();
      if(term.length<2){hide();return;}
      timer=setTimeout(async()=>{
        controller=new AbortController();const current=controller;
        panel.hidden=false;input.setAttribute('aria-expanded','true');status.textContent=form.dataset.loading;list.replaceChildren();
        try{
          const parts=await Promise.all([request(term,current.signal),looksSku(term)?request('sku:"'+term+'"',current.signal):Promise.resolve([])]);
          if(input.value.trim()!==term||current.signal.aborted)return;
          const items=ranked([...parts[1].filter(item=>item.dataset.exactSku==='true'),...parts[0]],term).slice(0,8);
          status.textContent=items.length?'':form.dataset.none;
          items.forEach(item=>{
            const link=document.createElement('a');link.href=item.dataset.url;link.className='ekl-search-item';
            const image=document.createElement('img');image.src=item.dataset.image;image.alt='';image.width=56;image.height=56;
            const info=document.createElement('span');const title=document.createElement('strong');title.textContent=item.dataset.title;const price=document.createElement('small');price.textContent=item.dataset.price;info.append(title,price);
            if(item.dataset.exactSku==='true'){const badge=document.createElement('small');badge.className='ekl-search-exact';badge.textContent=form.dataset.exact;info.prepend(badge);}
            link.append(image,info);list.append(link);
          });
          const all=document.createElement('a');all.className='ekl-search-all';all.href=base+'?'+new URLSearchParams({q:term,type:'product','options[unavailable_products]':'last'});all.textContent=form.dataset.all+' →';list.append(all);
        }catch(error){if(error.name!=='AbortError')hide();}
      },250);
    });
    input.addEventListener('keydown',event=>{if(event.key==='Escape')hide();if(event.key==='ArrowDown'&&!panel.hidden){event.preventDefault();list.querySelector('a')?.focus();}});
    panel.addEventListener('keydown',event=>{if(event.key==='Escape'){hide();input.focus();}if(event.key==='ArrowDown'||event.key==='ArrowUp'){const links=[...list.querySelectorAll('a')],index=links.indexOf(document.activeElement);event.preventDefault();links[(index+(event.key==='ArrowDown'?1:-1)+links.length)%links.length]?.focus();}});
    document.addEventListener('click',event=>{if(!form.contains(event.target))hide();});
    form.addEventListener('focusout',event=>{if(!form.contains(event.relatedTarget))hide();});
  });
  const results=document.querySelector('[data-ek-search-results]');
  if(results&&looksSku(results.dataset.searchTerm)){
    const term=results.dataset.searchTerm;
    const sort=new URLSearchParams(location.search).get('sort_by');
    if((!sort||sort==='relevance')&&![...new URLSearchParams(location.search).keys()].some(key=>key.startsWith('filter.'))) request('sku:"'+term+'"').then(items=>{
      const grid=results.querySelector('[data-ekc-grid]');if(!grid)return;
      ranked(items,term).filter(item=>item.dataset.exactSku==='true').reverse().forEach(item=>{
        const card=item.firstElementChild;if(!card)return;
        [...grid.children].forEach(existing=>{if([...existing.querySelectorAll('a')].some(a=>a.pathname===new URL(item.dataset.url,location.origin).pathname))existing.remove();});
        grid.prepend(card);
      });
    }).catch(()=>{});
  }
})();
